var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content dashboard", attrs: { id: "app" } },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "dash-item col-sm-6" },
          [
            _c(
              "router-link",
              {
                attrs: { slot: "item-title", to: "/super-admin/accounts" },
                slot: "item-title",
              },
              [
                _c("div", { staticClass: "dashbox" }, [
                  _c("div", { staticClass: "desc" }, [
                    _vm.isDashoardLoaded
                      ? _c("span", { staticClass: "amount" }, [
                          _vm._v(_vm._s(_vm.getAccounts)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("dashboard.cards.accounts"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "icon" },
                    [_c("contact-icon", { staticClass: "card-icon" })],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dash-item col-sm-6" },
          [
            _c(
              "router-link",
              {
                attrs: { slot: "item-title", to: "/super-admin/invoices" },
                slot: "item-title",
              },
              [
                _c("div", { staticClass: "dashbox" }, [
                  _c("div", { staticClass: "desc" }, [
                    _vm.isDashoardLoaded
                      ? _c("span", { staticClass: "amount" }, [
                          _vm._v(_vm._s(_vm.getInvoices)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("dashboard.cards.invoices"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "icon" },
                    [_c("invoice-icon", { staticClass: "card-icon" })],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dash-item col-sm-6" },
          [
            _c(
              "router-link",
              {
                attrs: {
                  slot: "item-title",
                  to: "/super-admin/purchase-orders",
                },
                slot: "item-title",
              },
              [
                _c("div", { staticClass: "dashbox" }, [
                  _c("div", { staticClass: "desc" }, [
                    _vm.isDashoardLoaded
                      ? _c("span", { staticClass: "amount" }, [
                          _vm._v(" " + _vm._s(_vm.getPurchaseOrders)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("dashboard.cards.purchase_orders"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "icon" },
                    [_c("estimate-icon", { staticClass: "card-icon" })],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12 mt-2" }, [
          _c("div", { staticClass: "card dashboard-card" }, [
            _c("div", { staticClass: "graph-body" }, [
              _c(
                "div",
                { staticClass: "card-body col-md-12 col-lg-12 col-xl-10" },
                [
                  _c("div", { staticClass: "card-header" }, [
                    _c("h6", [
                      _c("i", { staticClass: "fa fa-line-chart text-primary" }),
                      _vm._v(
                        _vm._s(_vm.$t("dashboard.activity_chart.title")) + " "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "year-selector mr-2" },
                      [
                        _c("base-date-picker", {
                          attrs: {
                            "calendar-button": true,
                            "calendar-button-icon": "calendar",
                            placeholder: _vm.$t("general.from"),
                          },
                          model: {
                            value: _vm.from_date,
                            callback: function ($$v) {
                              _vm.from_date = $$v
                            },
                            expression: "from_date",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "year-selector mr-2" },
                      [
                        _c("base-date-picker", {
                          attrs: {
                            "calendar-button": true,
                            "calendar-button-icon": "calendar",
                            placeholder: _vm.$t("general.to"),
                          },
                          model: {
                            value: _vm.to_date,
                            callback: function ($$v) {
                              _vm.to_date = $$v
                            },
                            expression: "to_date",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "year-selector mr-2" },
                      [
                        _c("base-select", {
                          attrs: {
                            options: _vm.accountOption,
                            "group-select": false,
                            searchable: true,
                            "show-labels": false,
                            placeholder: _vm.$t("dashboard.select_account"),
                            "group-values": "options",
                            "group-label": "label",
                            "track-by": "id",
                            label: "company_name",
                          },
                          model: {
                            value: _vm.selectedAccount,
                            callback: function ($$v) {
                              _vm.selectedAccount = $$v
                            },
                            expression: "selectedAccount",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isLoaded
                    ? _c("bar-chart", {
                        attrs: {
                          label: _vm.selected_user_type,
                          labels: _vm.chartData.labels,
                          values: _vm.chartData.values,
                          backgroundColor: _vm.chartData.colors,
                          borderColor: _vm.chartData.colors,
                          hoverBackgroundColor: _vm.chartData.colors,
                          hoverBorderColor: _vm.chartData.colors,
                          updateChart: _vm.updateChart,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chart-desc col-md-12 col-lg-12 col-xl-2" },
                [
                  _vm.updateChart && _vm.isLoaded
                    ? _c(
                        "div",
                        { staticClass: "stats" },
                        _vm._l(_vm.chartData.info, function (info) {
                          return _c(
                            "div",
                            { key: info.label, staticClass: "description" },
                            [
                              _c("span", { staticClass: "title" }, [
                                _vm._v(" " + _vm._s(info.label) + " "),
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "total",
                                  style: { color: info.color },
                                },
                                [
                                  info.label == "Total Financed"
                                    ? _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$utils.formatMoney(
                                              info.count,
                                              _vm.defaultCurrency
                                            )
                                          ),
                                        },
                                      })
                                    : _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(info.count),
                                        },
                                      }),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }